import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router';
import { AppProvider, useApp } from './lib/app';
import { configured } from './lib/supabase';
import { Shell } from './ui/Shell';
import { PresenceProvider } from './lib/presence';
import { ConnectionProvider } from './lib/connection';
import { ToastHost } from './ui/kit';
import { ViewerHost } from './ui/Viewer';
import Login from './routes/Login';
import SetPassword from './routes/SetPassword';
import Home from './routes/Home';
import Buildings from './routes/Buildings';
import BuildingPage from './routes/BuildingPage';
import Contracts from './routes/Contracts';
import Orgs from './routes/Orgs';
import Files from './routes/Files';
import Admin from './routes/admin/Admin';
import Register from './routes/Register';
import ItemPage from './routes/ItemPage';
import Search from './routes/Search';
import Payments from './routes/Payments';
import Weekly from './routes/Weekly';
import WeeklyReport from './routes/WeeklyReport';
import Daily from './routes/Daily';
import DailyDay from './routes/DailyDay';
import { C3PageLoading } from './ui/C3Loader';

function Splash() {
  return (
    <div className="auth">
      <C3PageLoading label="Loading PM C3" size={96} />
    </div>
  );
}

function Gate() {
  const { ready, session } = useApp();
  const loc = useLocation();
  if (!ready) return <Splash />;
  if (loc.pathname === '/set-password') return <SetPassword />;
  if (!session || !configured) return <Login welcome={loc.pathname === '/welcome'} />;
  return (
    <PresenceProvider>
    <ConnectionProvider>
    <Shell>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/buildings" element={<Buildings />} />
        <Route path="/buildings/:id" element={<BuildingPage />} />
        <Route path="/contracts" element={<Contracts />} />
        <Route path="/orgs" element={<Orgs />} />
        <Route path="/files" element={<Files />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/r/:module" element={<Register />} />
        <Route path="/r/:module/:id" element={<ItemPage />} />
        <Route path="/search" element={<Search />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/weekly" element={<Weekly />} />
        <Route path="/weekly/:id" element={<WeeklyReport />} />
        <Route path="/daily" element={<Daily />} />
        <Route path="/daily/:date" element={<DailyDay />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
    </ConnectionProvider>
    </PresenceProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <ToastHost>
          <ViewerHost>
            <Gate />
          </ViewerHost>
        </ToastHost>
      </AppProvider>
    </BrowserRouter>
  );
}
